export default __webpack_public_path__ + "static/media/02.1412abb9.jpg";